export const GET_TARGET_ACC = 'GET_TARGET_ACC';
export const SET_TARGET_ACC = 'SET_TARGET_ACC';
export const ERROR_TARGET_ACC = 'ERROR_TARGET_ACC';